<div class="modal-backdrop fade show" *ngIf="showModal"></div>

<div
  class="modal fade show d-block"
  *ngIf="showModal"
  style="background: rgba(0, 0, 0, 0.45)"
>
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <form [formGroup]="planForm" (ngSubmit)="submit()">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ subscriptionData ? "Update Plan" : "Add Plan" }}
          </h5>
          <button type="button" class="btn-close" (click)="close()"></button>
        </div>

        <div class="modal-body">
          <div class="row">
            <!-- Plan Name -->
            <div class="col-6 mb-2">
              <label>Plan Name</label>
              <input
                class="form-control"
                type="text"
                formControlName="name"
                placeholder="Enter Plan Name"
              />
              <small
                class="text-danger"
                *ngIf="
                  planForm.get('name')?.touched &&
                  planForm.get('name')?.hasError('required')
                "
              >
                Plan name is required
              </small>
            </div>

            <!-- Plan Type -->
            <div class="col-6 mb-2">
              <label>Plan Type</label>
              <select class="form-control" formControlName="planType">
                <option [ngValue]="1">Main Plan</option>
                <option [ngValue]="2">Top Up</option>
              </select>
              <small
                class="text-danger"
                *ngIf="
                  planForm.get('planType')?.touched &&
                  planForm.get('planType')?.hasError('required')
                "
              >
                Plan type is required
              </small>
            </div>

            <!-- Price -->
            <div class="col-6 mb-2">
              <label>Price</label>
              <input
                class="form-control"
                type="number"
                min="0"
                formControlName="price"
              />
              <small
                class="text-danger"
                *ngIf="
                  planForm.get('price')?.touched &&
                  planForm.get('price')?.hasError('required')
                "
              >
                Price is required
              </small>
            </div>
            <!-- Trip KM -->
            <!-- <div class="col-6 mb-2">
              <label>Trip KM</label>
              <input
                class="form-control"
                type="number"
                min="0"
                formControlName="tripKM"
              />
              <small
                class="text-danger"
                *ngIf="
                  planForm.get('tripKM')?.touched &&
                  planForm.get('tripKM')?.hasError('required')
                "
              >
                Trip KM is required
              </small>
            </div> -->
            <!-- <div class="col-6 mb-2" *ngIf="planForm.value.planType == 2">
  <label>Extra KM</label>
  <input class="form-control" type="number" min="0" formControlName="extraKM"/>
  <small class="text-danger"
    *ngIf="planForm.get('extraKM')?.touched && planForm.get('extraKM')?.hasError('required')">
    Extra KM required
  </small>
</div> -->

            <div class="col-6 mb-2">
              <label>Trip KM</label>
              <input
                class="form-control"
                type="number"
                formControlName="tripKM"
              />
            </div>

            <div class="col-6 mb-2" *ngIf="planForm.value.planType == 1">
              <label>Validity Days</label>
              <input
                class="form-control"
                type="number"
                formControlName="validityDays"
              />
            </div>

            <!-- Stops Per Trip -->
            <div class="col-6 mb-2" *ngIf="planForm.value.planType == 1">
              <label>Stops Per Trip</label>
              <input
                class="form-control"
                type="number"
                min="0"
                formControlName="stopsPerTrip"
              />
              <small
                class="text-danger"
                *ngIf="
                  planForm.get('stopsPerTrip')?.touched &&
                  planForm.get('stopsPerTrip')?.hasError('required')
                "
              >
                Stops are required
              </small>
            </div>

            <!-- Validity -->
            <!-- <div class="col-6 mb-2">
              <label>Validity Days</label>
              <input
                class="form-control"
                type="number"
                min="0"
                formControlName="validityDays"
              />
              <small
                class="text-danger"
                *ngIf="
                  planForm.get('validityDays')?.touched &&
                  planForm.get('validityDays')?.hasError('required')
                "
              >
                Validity is required
              </small>
            </div> -->

            <!-- Tax -->
            <div class="col-6 mb-2">
              <label>Tax (%)</label>
              <input
                class="form-control"
                type="number"
                min="0"
                formControlName="tax"
              />
              <small
                class="text-danger"
                *ngIf="
                  planForm.get('tax')?.touched &&
                  planForm.get('tax')?.hasError('required')
                "
              >
                Tax is required
              </small>
            </div>

            <!-- Commission -->
            <div class="col-6 mb-2">
              <label>Commission (%)</label>
              <input
                class="form-control"
                type="number"
                min="0"
                formControlName="commission"
              />
              <small
                class="text-danger"
                *ngIf="
                  planForm.get('commission')?.touched &&
                  planForm.get('commission')?.hasError('required')
                "
              >
                Commission is required
              </small>
            </div>

            <!-- Discount -->
            <div class="col-6 mb-2">
              <label>Discount (%)</label>
              <input
                class="form-control"
                type="number"
                min="0"
                formControlName="discount"
              />
              <small
                class="text-danger"
                *ngIf="
                  planForm.get('discount')?.touched &&
                  planForm.get('discount')?.hasError('required')
                "
              >
                Discount is required
              </small>
            </div>

            <!-- Plan Index -->
            <div class="col-6 mb-2">
              <label>Plan Index</label>
              <input
                class="form-control"
                type="number"
                min="0"
                formControlName="planIndex"
              />
              <small
                class="text-danger"
                *ngIf="
                  planForm.get('planIndex')?.touched &&
                  planForm.get('planIndex')?.hasError('required')
                "
              >
                Plan index is required
              </small>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="close()">
            Close
          </button>
          <button type="submit" class="btn btn-primary">Save</button>
        </div>
      </form>
    </div>
  </div>
</div>
